import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { isEnabledUserRole } from '../../../utils/utils';
import { isEnabledSendLetter } from '../../../utils/planUtils';
import * as URI from 'urijs';
import Button from 'material-ui/Button';
import Download from '../../Icons/Download';

const styles = () => ({
  btn: {
    height: '33px',
    boxSizing: 'border-box',
    color: '#5A5B62',
    fontSize: '13px',
    border: '1px solid #D8DBDF',
    marginRight: '12px',
    textTransform: 'capitalize'
  },
});

class ExportSentExecutiveListButton extends React.Component {
  /**
   * 表示するかどうか真偽値を返す
   *
   * @return bool
   */
  isRender = () => {
    const { user } = this.props;
    return !!user;
  }

  handleClick = () => {
    const { user } = this.props;

    if (
      !isEnabledUserRole(user, "executive-list", "download-letter-ordered-list") &&
      !isEnabledUserRole(user, "house-list", "download-list")
    ) {
      window.confirm(`アクセス権限がありません。アカウント管理者にお問い合わせください`);
    } else {
      if (window.confirm(`注文済みキーマンを全件エクスポートします。よろしいですか？`)) {
        let query = {};
        let path = 'letter_order_addresses/csv';

        let url = URI(process.env.REACT_APP_API_BASE_URL + path);
        url = url.query(query);
        window.open(url);
      }
    }
  }

  render() {
    const { classes, user } = this.props;

    return (
      this.isRender() ? (
        <Button
          className={classes.btn}
          onClick={(isEnabledSendLetter(user)) ? this.handleClick : this.props.togglePlanDialog}>
          <Download width={16} height={16} color={isEnabledSendLetter(user) ? "#B1B3B9" : "#5A5B62"} style={{ marginRight: '5px' }} />
          注文済みキーマンをエクスポート
        </Button>
      ) : null
    );
  }
}

ExportSentExecutiveListButton.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  user: PropTypes.object,
  togglePlanDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(ExportSentExecutiveListButton);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/parts/ExportSentExecutiveListButton.jsx